import { AreaDetail } from "../types";
import { apiDomain } from "../utils/climbingAreaUtils";
import { ApiError } from "./apiError";

async function fetchAreaDetailExtended(areaId: string): Promise<AreaDetail | null> {
    const baseUrl = new URL("https://" + apiDomain());
    const url = new URL('/area/' + areaId + '/detail', baseUrl);
    url.searchParams.set('includeClim81Station', 'true');

    const response = await fetch(url.toString());
    if (!response.ok) {
        // This endpoint answers 404 for an unknown area (the forecast endpoint answers 500)
        return Promise.reject(new ApiError(response.statusText, response.status));
    }

    const areaDetail: AreaDetail = await response.json();
    return areaDetail;
}

export default fetchAreaDetailExtended;
